import { memo } from "react"
import { HISTORIA_MODERNA_IMAGE_NAME, HISTORIA_MODERNA_URL, HISTORY_FEST_IMAGE_NAME, HISTORY_FEST_URL } from "../../HistoriografijaConstants"
import { getThumbnailImageUrl } from "../../services/CommonService"
import Add from "./Add"

const Advertisement = memo(function Advertisement() {

    return (
        <div className="flex-container flex-column">
            <Add 
                title="Časopis Historia Moderna"
                url={HISTORIA_MODERNA_URL}
                image={{
                    "imageName": getThumbnailImageUrl(HISTORIA_MODERNA_IMAGE_NAME),
                    "altText": "Historia Moderna casopis"
                }}
            />

            <Add 
                title="History Fest"
                url={HISTORY_FEST_URL}
                image={{
                    "imageName": getThumbnailImageUrl(HISTORY_FEST_IMAGE_NAME),
                    "altText": "History Fest"
                }}
            />
        </div>
    )
})

export default Advertisement